"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_MESSAGES = {
    addUserEmptyEmail: {
        message: 'Email cannot be empty.',
    },
    addUserEmptyPassword: {
        message: 'Password cannot be empty.',
    },
    addUserLongPassword: {
        message: 'Password cannot be longer then 20 characters.',
    },
    addUserPasswordPattern: {
        message: 'Password have to contain at least one capital, one small case latter and one digit.',
    },
    addUserSmallPassword: {
        message: 'Password cannot be shorter then 8 characters.',
    },
    addUserWrongEmailPattern: {
        message: `The parameter of Email doesn't match email pattern.`,
    },
};
